import fancy from '../../../../assets/images/error-images/fancy.svg'
import NoData from '../../noData'
import FancyList from './fancyList'

export default function Fancy({ data }: { data: { sessions: unknown[] } }) {
  const hasData = data?.sessions && data.sessions.length > 0
  return (
    <div className="container">
      {hasData ? (
        <section className="mb-6">
          <FancyList fancyList={data?.sessions} />
        </section>
      ) : (
        <NoData imagePath={fancy} />
      )}
    </div>
  )
}
